import React from 'react';

export function HelpSection({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-24 mb-12">
      <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100" style={{ fontFamily: 'Manrope' }}>
        {title}
      </h2>
      {children}
    </section>
  );
}
